import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSwap16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowSwap16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.147 7.266a.5.5 0 0 0 .707.707l2.121-2.121.354-.354-.354-.353-2.121-2.122a.5.5 0 0 0-.707.708L12.416 5H2.5a.5.5 0 0 0 0 1h9.913zM4.854 8.733 3.587 10H13.5a.5.5 0 0 1 0 1H3.585l1.269 1.269a.5.5 0 1 1-.707.707l-2.122-2.122-.353-.353.353-.354 2.122-2.121a.5.5 0 0 1 .707.707"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowSwap16);
